module.exports = __webpack_public_path__ + "static/KapraNeuePro-LightExp-2989afba7ccd844c5581a32286f63cea.woff";